import * as T from 'src/store/types'
import Vue from 'vue'
import { SET_ESAC_POINTS_REDEMPTION_DATA, SET_ESAC_POINTS_REDEMPTION_LIST } from 'src/store/types'

export default {
  [T.SET_ESAC_POINTS_VOUCHER_DATA](state, payload = {}) {
    Vue.set(state.voucherData, 'data', payload)
  },
  [T.SET_ESAC_POINTS_VOUCHER_LIST](state, payload = false) {
    Vue.set(
      state.voucherList,
      'list',
      payload
        ? payload.list
        : {
            data: [],
            total: 0,
          }
    )
  },
  [T.SET_ESAC_POINTS_REDEMPTION_LIST](state, payload) {
    Vue.set(state.redemptionList, 'list', payload.list)
  },
  [T.SET_ESAC_POINTS_REDEMPTION_DATA](state, payload) {
    Vue.set(state.redemption, 'data', payload.data)
  },
  [T.SET_ITOKEN_ACCUMULATE_CALCULATION_LIST](state, payload) {
    Vue.set(state.accumulateCalculationList, 'list', payload.list)
  },
  [T.SET_ESAC_POINTS_BALANCE](state, data) {
    state.balance = data
  },
}
